import { ConfigProvider, Modal } from 'antd';
import React from 'react';

export const outLoginModal = () => {
  return Modal.confirm({
    title: '提示',
    content: '登录已过期，请重新登录',
    onOk: () => {
      // history.replace('/auth/login');
      location.href = '/auth/login';
      // location.reload();
    },
    okText: '重新登录',
    maskClosable: false,
    footer: (originNode, { OkBtn }) => {
      // @ts-ignore
      return (
        <ConfigProvider
          theme={{
            token: {
              fontSize: 12,
              borderRadius: 4,
              colorPrimary: '#172c4d',
              colorBgLayout: '#fafafa',
              colorBorderSecondary: '#e7eaef',
            },
          }}
        >
          <OkBtn />
        </ConfigProvider>
      );
    },
  });
};
